import React from 'react'
import {findDOMNode} from "react-dom"

import PopoverComponent, {
    PopoverComponentProps, PopoverComponentState
} from "../../../../../../core/gd-components/base-component/popover-component"

import Popover from '../../../../../../core/gd-components/gd-popover/popover-v2'
import PopoverPosition from '../../../../../../core/gd-components/gd-popover/popover-position'
import {PopoverAttachmentType} from '../../../../../../core/gd-components/gd-popover/@const'

import PopupMenuButton from "../../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import ProjectCollectionView_MoreMenu from "../submenu-item/more-popover/more-menu"
import ProjectCollectionView
    from "../../../../../../core/manager/project-collection/project-collection-views/project-collection-view";

type Props = {
    projectCollectionId : ID
    defaultInfo         : string

    additionalViews     : any[]
} & PopoverComponentProps

export default class ProjectCollectionMenuMore extends PopoverComponent<Props, PopoverComponentState> {

    static defaultProps = {
        defaultInfo     : 'Select view',
        additionalViews : []
    }

    selectPreset = (view: any) => {
        this.hidePopover()
        gd.goTo(view.url)
    }

    renderItem = (key: number, view: ProjectCollectionView) => {
        return (
            <div key={key} className="option with-more" onClick={()=>this.selectPreset(view)}>
                <div className="label">{view.name}</div>

                {view.hasMoreMenu &&
                <PopupMenuButton className="ui5-ico-more s20 gd-ui-more-button-container"
                                 popoverClass="popover-project-view"
                                 attachment="top left"
                                 targetAttachment="top right"
                                 offset="12px -4px"
                                 menuComponent={ProjectCollectionView_MoreMenu}
                                 menuParams={{
                                     view: view
                                 }}/>}
            </div>
        )
    }

    renderPopover() {
        if (this.state.showPopover) {
            const popoverPosition = new PopoverPosition({
                attachment      : "top center",
                targetAttachment: "bottom center",
                attachmentType  : PopoverAttachmentType.HORIZONTAL,
            })

            return (
                <Popover position={popoverPosition}
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={() => findDOMNode(this)}>

                    <div className="ui5-popover-menu">

                        {_.map(this.props.additionalViews, (view, key) =>
                            <div key={key} className="option with-more" onClick={this.selectPreset.bind(this, view)}>
                                <div className="label">{view.name}</div>

                                {view.access === 'private' && <div className="ui5-ico-12 i5-lock"></div>}

                                {view.hasMoreMenu &&
                                    <PopupMenuButton className="ui5-ico-more s20 gd-ui-more-button-container"
                                                     popoverClass="popover-project-view"
                                                     attachment="top left"
                                                     targetAttachment="top right"
                                                     offset="12px -4px"
                                                     menuComponent={ProjectCollectionView_MoreMenu}
                                                     menuParams={{
                                                         view: view
                                                     }}/>}
                            </div>
                        )}
                    </div>
                </Popover>
            )
        }
    }

    render() {
        return (
            <div className="item with-counter" onClick={this.showPopover}>
                <div className="label">More</div>
                <div className="counter">{this.props.additionalViews.length}</div>

                <div className="ui5-triangle-toggle s7 open"/>
                {this.renderPopover()}
            </div>
        )
    }
}
